export default __webpack_public_path__ + "static/media/reach_handlebar.17563141.jpeg";